const DeliveryTipEvent = {
  messages: ['배달팁 할인 이벤트가 진행중입니다.', '(~2020년 8월 31일까지)']
}

const NewCustomerProductEvent = {
  messages: [],
  catalogId: process.env.VUE_APP_NEW_CUSTOMER_PRODUCT_EVENT_CATALOG_ID
}

export {
  DeliveryTipEvent,
  NewCustomerProductEvent
}

export default {}